import {
  retrieveAccessToken,
} from 'utils/Client/apiRequest'

import { OE_CLIENT }  from 'utils/Client/userTypes'
import { redirect } from 'redux-first-router'
import {
  handleCoreRequests,
  handleCoreOverviewRequests,
  handleCorePortfolioRequests,
  handleCoreDocumentsRequests,
} from 'routing/thunks/handlers/client'
import { setToken } from 'utils/tokens'
import {
  getRedirectLocation,
  removeRedirectLocation,
  defaultRedirectLocations,
} from 'utils/Client/redirects'
import { goDocumentsSubSection } from 'actions/client/routing.js'
import actions from 'actions/index'

const {
  setIsLoading,
  setRedirection,
} = actions

const redirectIfSharedRoute = async (dispatch, getState) => {
  const {
    location: { payload },
    user: { user: { onlineExperienceType } }
  } = getState()
  const typeOfDocument = onlineExperienceType === OE_CLIENT ? 'statements' : 'proposals'

  if (payload.documentListType === 'shared') {
    dispatch(redirect(goDocumentsSubSection(typeOfDocument)))
  }
}

export const onBeforeChangeClient = async (dispatch) => {
  dispatch(setRedirection(false))
}

export const handleOverviewPage = async (dispatch, getState) => {
  await handleCoreOverviewRequests(dispatch, getState)
}

export const handlePortfolioPage = async (dispatch, getState) => {
  await handleCorePortfolioRequests(dispatch, getState)
}

export const handleDocumentsPage = async (dispatch, getState) => {
  redirectIfSharedRoute(dispatch, getState)
  await handleCoreDocumentsRequests(dispatch, getState)
}

export const handleProfileSettingsPage = async (dispatch, getState) => {
  await handleCoreRequests(dispatch, getState)
}

export const handleUploaderPage = async (dispatch, getState) => {
  await handleCoreDocumentsRequests(dispatch, getState)
}

export const setLoginToken = async (dispatch, getState) => {
  dispatch(setIsLoading(true))
  const { location: { payload: { code } } } = getState()
  const locationToRedirect = getRedirectLocation() || defaultRedirectLocations.client

  removeRedirectLocation()

  const authResponse = await retrieveAccessToken(code)
  const accessToken = authResponse.access_token

  setToken('accessToken', accessToken, 'local')

  dispatch(redirect(locationToRedirect))
}

export default onBeforeChangeClient



// WEBPACK FOOTER //
// ./src/routing/thunks/client.js